/*
 *
 * BaseLayout constants
 *
 */
import { logout } from 'utils/common';
import Analytics from 'utils/analytics';
import EVENTS from 'constants/analytics';

const BASE_ACTION_CONSTANT = 'app/BaseLayout';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const GET_MERCHANT_DETAILS = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_DETAILS`;

export const menuItems = [
  {
    key: 'invoice',
    value: 'Invoice',
    onClick: () => {
      setTimeout(() => {
        window.location.href = `${
          process.env.COMMON_BASE_PATH
        }/profile/invoice`;
      }, 50);
    },
  },
  {
    key: 'logout',
    value: 'Sign Out',
    onClick: () => {
      logout();
      Analytics.track(EVENTS.SHELL_V2.NAV_PROFILE_SIGNOUT_CLICKED, {
        Response: 'click',
      });
    },
  },
];

export const keyKeyMapping = {
  pg: 'PG',
  payout: 'CSP',
  baas: 'BAAS',
  'auto-collect': 'CAC',
  'easy-split': 'CES',
  cashgram: 'CG',
  softpos: 'EPOS',
  crossborder: 'LRS',
  'global-collections': 'GCL',
  'payment-links': 'ORDERS',
  'payment-forms': 'PF',
  ROUTER: 'ROUTER',
  subscriptions: 'SBC',
  'verification-suite': 'VRS',
  RISKSHIELD: 'RISKSHIELD',
  flowwise: 'FLOWWISE',
};

export const COACHMARK_STEPS = [
  {
    target: '.insights-ai',
    disableBeacon: true,
    placement: 'bottom',
    disableOverlay: true,
    disableScrolling: false,
  },
];
